import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { JiraObjectDataset } from 'app/model/dataset/jira.dataset';
import { Metamodel } from 'app/model/base/model';
import { JiraLinkedService } from 'app/model/linkedservice/jira.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { GlobalVariables } from 'app/services/globals';

export const jiraObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(JiraObjectDataset).name,
    displayName: stringResources.Jira_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(JiraLinkedService).name],
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-jira',
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-jira'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    notSupportCopySourceQuery:  GlobalVariables.enableQueryJiraV2 ? false :`{ linkedService && linkedService.version === "v2" }`,
    category: ['ServicesApps'],
    isTableRequired: true,
    schemaAlias: 'schema'
};
